import axios from 'axios';
import { atom, useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';
import useSystem from 'hooks/business/system/useSystem';

const countryCodeLanguageMap: Record<string, string> = {
  CN: 'zh-CN',
  ID: 'id',
  TH: 'th',
  US: 'en-US',
  VN: 'vi',
  BR: 'pt',
  TW: 'zh-CN',
  PH: 'tl',
  MY: 'ms',
  PL: 'pl',
  ES: 'es',
  CL: 'es',
  CO: 'es',
  MX: 'es',
};

const SYSTEM_COUNTRY_KEY = 'fett/countryCode';
const IP_KEY = 'fett/ip';

const countryCodeAtom = atom<string | null>(sessionStorage.getItem(SYSTEM_COUNTRY_KEY) ?? null);
const countryCodeState = atom(
  (get) => get(countryCodeAtom),
  (_, set, newValue: string | null) => {
    set(countryCodeAtom, newValue);
    if (newValue) {
      sessionStorage.setItem(SYSTEM_COUNTRY_KEY, newValue);
    }
  },
);
const ipAtom = atom<string | null>(sessionStorage.getItem(IP_KEY) ?? null);
const ipState = atom(
  (get) => get(ipAtom),
  (_, set, newValue: string | null) => {
    set(ipAtom, newValue);
    if (newValue) {
      sessionStorage.setItem(IP_KEY, newValue);
    }
  },
);

export const useCountryCodeValue = () => useAtomValue(countryCodeState);
export const useIpValue = () => useAtomValue(ipState);

const getCountryCodeFromIp = () => {
  return Promise.any<any>([
    axios.get('https://prq-api.leyanbot.com/oversea_locust_proxy/get_ip_info'),
    // axios.get("http://ip123.in/ip.json"),
  ])
    .then((response: any) => {
      return response?.data;
    })
    .catch(() => {
      return null;
    });
};

const SYSTEM_SETTING_STORAGE_KEY = 'fett/systemSetting';
const language = (() => {
  const storage = localStorage.getItem(SYSTEM_SETTING_STORAGE_KEY);
  try {
    if (storage) {
      const cached = JSON.parse(storage) as any;
      return cached.language;
    }
  } catch (e) {
    return undefined;
  }
})();

export const useCountryCodeInitial = () => {
  const { handleLanguageSettingChange } = useSystem();
  const setCountryCode = useSetAtom(countryCodeState);
  const setIp = useSetAtom(ipState);

  useEffect(() => {
    getCountryCodeFromIp().then((data) => {
      const countryCode = data?.countryCode || data?.country_code || data?.country || null;
      const ip = data?.ip || null;
      if (!language) {
        handleLanguageSettingChange(
          (countryCodeLanguageMap[countryCode || ''] || 'en-US') as General.SystemLanguage,
        );
      }
      setCountryCode(countryCode);
      setIp(ip);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
